import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	pageHeader: {
		id: 'spa-apps-compass-product-settings.page-header',
		defaultMessage: 'Compass',
		description: 'Title for a page where site admins can update compass product settings',
	},
	pageSubheaderSpork: {
		id: 'spa-apps-compass-product-settings.page-subheader-spork',
		defaultMessage: 'Control how Compass integrates with Jira.',
		description: 'Description for a page where site admins can update compass product settings',
	},
	pageSubheaderSporkLink: {
		id: 'spa-apps-compass-product-settings.page-subheader-spork-link',
		defaultMessage: 'Learn about Compass components in Jira',
		description: 'Link for site admins to learn more about Compass components in Jira',
	},
	changesSavedSuccessFlag: {
		id: 'spa-apps-compass-product-settings.changes-saved-success-flag',
		defaultMessage: 'Compass integration settings saved',
		description: 'Flag success message confirming changes have been saved',
	},
	projectDefaultSettingTitle: {
		id: 'spa-apps-compass-product-settings.project-default-setting-title',
		defaultMessage: 'Project defaults',
		description: 'Title for project default settings',
	},
	projectDefaultSettingCompassOption: {
		id: 'spa-apps-compass-product-settings.project-default-setting-compass-option',
		defaultMessage: 'New projects use Compass components',
		description: 'Project default setting Compass option',
	},
	projectDefaultSettingCompassOptionDescription: {
		id: 'spa-apps-compass-product-settings.project-default-setting-compass-option-description',
		defaultMessage:
			'Site and project admins can still switch to Jira components after the project is created.',
		description: 'Project default setting Compass option',
	},
	projectDefaultSettingJiraOption: {
		id: 'spa-apps-compass-product-settings.project-default-setting-jira-option',
		defaultMessage: 'New projects use Jira components',
		description: 'Project default setting Jira option',
	},
	projectDefaultSettingJiraOptionDescription: {
		id: 'spa-apps-compass-product-settings.project-default-setting-jira-option-description',
		defaultMessage:
			'Site and project admins can still switch to Compass components after the project is created.',
		description: 'Project default setting Jira option',
	},
	projectDefaultSettingSave: {
		id: 'spa-apps-compass-product-settings.project-default-setting-save',
		defaultMessage: 'Save',
		description: 'Project default setting save button',
	},
	projectDefaultSettingDiscardChanges: {
		id: 'spa-apps-compass-product-settings.project-default-setting-discard-changes',
		defaultMessage: 'Discard changes',
		description: 'Project default setting discard changes button',
	},
});
